import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import { getUrlLangPrefix } from "@/utils/Local";

import AwardsComponent from "../components/Awards.component";
import BannerComponent from "../components/Banner.component";
import BreadcrumbComponent, {
  buildBreadcrumbJsonLd,
} from "../components/Breadcrumb.component";
import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const Awards = (): React.JSX.Element => {
  const { t } = i18n;
  const langPrefix = getUrlLangPrefix();

  const breadcrumbs = [
    { label: t("gallery"), to: `${langPrefix}/${t("_route.gallery")}` },
    { label: t("Awards") },
  ];

  return (
    <React.Fragment>
      <DocumentComponent
        jsonLd={buildBreadcrumbJsonLd(breadcrumbs)}
        title={t("Awards")}
      />
      <BreadcrumbComponent items={breadcrumbs} />
      <BannerComponent description="" title={t("Awards")} />
      <Container className="mb-5 galleryContainer">
        <AwardsComponent />
      </Container>

      <ScheduleComponent />
    </React.Fragment>
  );
};

export default Awards;
